import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import VisuallyHidden from 'components/atoms/VisuallyHidden';
import Heading, { H3 } from 'components/atoms/Heading';
import uniqueSlug from 'unique-slug';
import * as styles from './Product.scss';

const Section = ({ children, className, title, accessibleTitle }) => {
  const id = uniqueSlug(title || accessibleTitle);
  return (
    <section
      className={classnames(styles.section, className)}
      aria-labelledby={id}
    >
      {!!accessibleTitle ? (
        <VisuallyHidden>
          <H3 id={id}>{accessibleTitle}</H3>
        </VisuallyHidden>
      ) : (
        <H3 id={id} className={styles.sectionTitle}>
          {title}
        </H3>
      )}
      {children}
    </section>
  );
};
Section.propTypes = {
  children: PropTypes.any,
  className: PropTypes.any,
  title: PropTypes.any,
  accessibleTitle: PropTypes.string,
};
export default Section;
